// Minimal node:url shim. The verifier path does not call into node:url
// at runtime; this exists so any unintentional import does not break the
// browser build.

export function fileURLToPath(input: string | URL): string {
  return typeof input === "string" ? input : input.pathname;
}

export function pathToFileURL(input: string): URL {
  return new URL(`file://${input.startsWith("/") ? input : `/${input}`}`);
}

export default { fileURLToPath, pathToFileURL };
